import { statusTone } from "../lib/format";

export function StatusBadge({ status }: { status?: string }) {
  if (!status) return null;
  return <span className={`badge ${statusTone(status)}`}>{status}</span>;
}
